import type { FC } from 'react'
import { Grid, Heading, Skeleton, Text } from '@chakra-ui/react'
import { useQuery } from 'react-query'
import {
	Card,
	ContentSection,
	ContentSectionHeading,
} from '@alexanderathoodly/ui-library'
import { getTestimonialsQuery } from './queries'
import { useLocationPage } from './context'
import { ImgProxy } from '~/utils/imgproxy'
import { useTranslation } from 'react-i18next'

export const TestimonialSection: FC = () => {
	const { t } = useTranslation()
	const { location } = useLocationPage()
	const result = useQuery(getTestimonialsQuery(location?.id))
	if (!result.data) {
		return null
	}
	if (result.isError) {
		return <span>Error: {result.error.message}</span>
	}
	const testimonials = result.data
	if (testimonials.length < 1) {
		return null
	}
	return (
		<ContentSection>
			<ContentSectionHeading>{t('Recensioner')}</ContentSectionHeading>
			{result.isLoading || result.isIdle ? (
				<Skeleton h={20} />
			) : (
				<Grid templateColumns="1fr" gap={2.5}>
					{testimonials.map((t) => {
						return (
							<Card
								colorScheme="green"
								key={t.id}
								display="grid"
								gridGap={4}
								gridTemplateColumns="max-content 1fr"
								gridTemplateRows="auto auto"
								alignItems="center"
								fontStyle="italic"
							>
								<Text whiteSpace="pre-wrap" gridColumn="1 / 3" color="grey.500">
									”{t.content}”
								</Text>
								<ImgProxy
									sizeSet={{ base: { width: 50, height: 50 } }}
									src={t.thumbnail}
									borderRadius="full"
									alt={t.person_name}
								/>
								<div>
									<Heading
										color="grey.800"
										fontWeight="semibold"
										fontSize="sm"
										mb={1}
									>
										{t.person_name},
									</Heading>
									<Text color="grey.500" fontSize="sm">
										{t.person_title} {t.company}
									</Text>
								</div>
							</Card>
						)
					})}
				</Grid>
			)}
		</ContentSection>
	)
}
